/**
 * Department tool card. Coverage shown as text + number so meaning is not
 * conveyed by color alone (WCAG 1.4.1). The visible text is the accessible
 * name; the bar is decorative.
 */
export default function ToolCard({ tool, onClick }) {
  const total = tool.total_members || 0;
  const have = tool.members_with_access || 0;
  const pct = total === 0 ? 0 : Math.round((have / total) * 100);

  return (
    <button type="button" className="dept2-tool-card" onClick={onClick} aria-haspopup="dialog">
      <span className="dept2-tool-card__top">
        <span className="dept2-tool-card__name">{tool.name}</span>
        {tool.is_dept_default && <span className="dept2-badge">Default</span>}
      </span>
      {tool.category_name && (
        <span className="dept2-tool-card__cat">{tool.category_name}</span>
      )}
      <span className="dept2-coverage" aria-hidden="true">
        <span className="dept2-coverage__bar" style={{ width: `${pct}%` }} />
      </span>
      <span className="dept2-tool-card__meta">
        {have} / {total} members{tool.i_have_access ? ' · You have access' : ''}
      </span>
    </button>
  );
}
